import script from "./mixCommons.vue?vue&type=script&lang=js"
export * from "./mixCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__